import possibleTypes from '@src/Api/Graphql/gql/introspection-result.generated';

export type ContentPossibleTypes =
  (typeof possibleTypes)['possibleTypes']['Content'][number];

export const ContentTypes = Object.fromEntries(
  (possibleTypes.possibleTypes.Content as string[]).map(type => [type, type]),
) as Record<ContentPossibleTypes, ContentPossibleTypes>;

type WithTypeName = {__typename?: string};

/**
 * Utilitaire centralisant les fonctions de vérification de type pour les objets Umbraco Content.
 *
 * Fournit des helpers pour vérifier dynamiquement le type d'un objet GraphQL (via __typename),
 * avec autocomplétion et sécurité de type grâce à ContentPossibleTypes.
 *
 * Usage :
 *   UmbTypeChecker.isType(obj, 'Course') // check générique
 *   UmbTypeChecker.isPaywall(obj)        // helper spécifique pour le type Paywall
 */
export class UmbTypeChecker {
  static isType<T extends ContentPossibleTypes>(
    obj: WithTypeName | undefined,
    type: T,
  ): obj is {__typename: T} {
    return obj?.__typename === type;
  }
  static isPaywall = (
    obj: WithTypeName | undefined,
  ): obj is {__typename: 'Paywall'} =>
    UmbTypeChecker.isType(obj, ContentTypes.Paywall);
}
